<template>
  <v-container class="page-wrap">
    <v-row>
      <v-col
        cols="12"
        style="padding-top: 0;">
        <div class="page-header mb-4 elevation-3">
          <h2 class="page-title">
            Order Fulfillment Setting
          </h2>
          <p class="page-subtitle caption grey--text">
            จัดการลำดับ Warehouse และ Min Stock สำหรับการจัดส่งสินค้า (แยกตาม Channel)
          </p>
        </div>

        <v-card
          flat
          class="rounded-lg elevation-3 pt-2"
          style="border: 1px solid #e8e8e8; height: calc(100vh - 180px);">
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="primary"
            class="setting-tabs"
          >
            <v-tab :key="'Default'">
              <v-icon
                small
                left>
                mdi-warehouse
              </v-icon>
              Default
            </v-tab>
            <v-tab :key="'Custom'">
              <v-icon
                small
                left>
                mdi-tune-variant
              </v-icon>
              Custom Rules
            </v-tab>
          </v-tabs>

          <v-divider />

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <OrderfulfillmentSettingDefaultNew />
            </v-tab-item>
            <v-tab-item>
              <OrderfulfillmentSettingCustomNew />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrderfulfillmentSettingDefaultNew from '../components/OrderfulfillmentSettingDefaultNew.vue'
import OrderfulfillmentSettingCustomNew from '../components/OrderfulfillmentSettingCustomNew.vue'

export default {
  components: {
    OrderfulfillmentSettingDefaultNew,
    OrderfulfillmentSettingCustomNew
  },
  data () {
    return {
      tab: 'Default'
    }
  }
}
</script>

<style lang="css" scoped>
.page-header {
  background-color: white;
  border-radius: 6px;
  padding: 16px;
}
.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.page-subtitle {
  margin: 4px 0 0;
}
.setting-tabs {
  padding: 0 8px;
}
</style>
